
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingMainPage from './components/landing/mlo-landing-page';
import Home from './Home';
import SearchMLO from './search-mlo/search';

import TermsOfUse from "./components/footer/terms-of-use"
import PrivacyPolicy from "./components/footer/privacy-policy"
import CaliforniaPolicy from "./components/footer/california-policy"
import Security from "./components/footer/security"
import Footer from './components/footer/Footer';
import Disclaimer from './components/footer/disclaimer';


const withFooter = (Page) => (
  <>
    <Page />
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchMLO />} />
        <Route path="/disclaimer" element={withFooter(Disclaimer)} />
        <Route path="/terms-of-use" element={withFooter(TermsOfUse)} />
        <Route path="/privacy-policy" element={withFooter(PrivacyPolicy)} />
        <Route path="/california-policy" element={withFooter(CaliforniaPolicy)} />
        <Route path="/security-policy" element={withFooter(Security)} />
        {/* AS_CQ-D002: footer/nav links use /borrower-portal/* — keep aliases to avoid blank pages */}
        <Route path="/borrower-portal" element={<Home />} />
        <Route path="/borrower-portal/search" element={<SearchMLO />} />
        <Route path="/borrower-portal/disclaimer" element={withFooter(Disclaimer)} />
        <Route path="/borrower-portal/terms-of-use" element={withFooter(TermsOfUse)} />
        <Route path="/borrower-portal/privacy-policy" element={withFooter(PrivacyPolicy)} />
        <Route path="/borrower-portal/california-policy" element={withFooter(CaliforniaPolicy)} />
        <Route path="/borrower-portal/security-policy" element={withFooter(Security)} />
      </Routes>
    </Router>
  );
}

export default App;


// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
// import { AuthProvider } from "./auth/auth-context-provide";
// import { RecoilRoot } from "recoil";
// import { ThemeProvider } from "@mui/material/styles";
// import "./font/Inter-Bold.ttf";
// import "./font/Inter-SemiBold.ttf";
// import "./font/Inter-Medium.ttf";
// import "./font/Inter-Regular.ttf";
// import "./font/DMSans-Medium.ttf";
// import "./font/DMSans-Regular.ttf";
// import "./font/DMSans-Bold.ttf";
// import "./font/DMSans-Italic.ttf";
// import { kstheme } from "./theme/theme";
// import { CssBaseline } from "@mui/material";
// import RecoilNexus from "recoil-nexus";

// const handleWheel = (event) => {
//   const tagName = event.target.tagName.toLowerCase();
//   if (tagName === "input" && event.target.type === "number") {
//     event.preventDefault();
//   }
// };

// ReactDOM.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <RecoilRoot>
//         <RecoilNexus />
//         <AuthProvider>
//           <ThemeProvider theme={kstheme}>
//             <CssBaseline>
//               <App />
//             </CssBaseline>
//           </ThemeProvider>
//         </AuthProvider>
//       </RecoilRoot>
//     </BrowserRouter>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// document.addEventListener("wheel", handleWheel, { passive: false });
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

